import { error as spectrumToastError } from "@react/react-spectrum/Toast";

/**
 * Shows a Spectrum error toast. Multiple calls stack as separate toasts.
 * Close/dismiss control is provided by Spectrum Toast (typically visible on hover/focus).
 *
 * @param {React.ReactNode} message
 * @param {{ timeout?: number, onClose?: () => void }} [options]
 */
export function showSpectrumErrorToast(message, options = {}) {
  const { timeout = 10000, onClose } = options;
  return spectrumToastError(message, {
    timeout,
    onClose: onClose || (() => {}),
  });
}
